module.exports = __webpack_public_path__ + "static/img/2.cc3bb19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/five/2.png
// module id = YNYD
// module chunks = 1